/* eslint-disable no-console */
export class LoggerUtil {
	static logInfo(message?: any, ...optionalParams: any[]): void {
		if (process.env.NODE_ENV === 'development') {
			console.log(`INFO: ${message}`, optionalParams);
		}
	}

	static logError(message?: any, ...optionalParams: any[]): void {
		if (process.env.NODE_ENV === 'development') {
			console.error(`ERROR: ${message}`, optionalParams);
		}
	}

	static logWarning(message?: any, ...optionalParams: any[]): void {
		if (process.env.NODE_ENV === 'development') {
			console.warn(`WARNING: ${message}`, optionalParams);
		}
	}
}
